export default {
    sidebar_dashboard: "Inicio",
    sidebar_payments_made: "Pagos Realizados",
    sidebar_current_credits: "Créditos Vigentes",
    sidebar_canceled_credits: "Créditos Cancelados",
    sidebar_statement: "Estado de cuenta",
    sidebar_certificates: "Certificados",
    sidebar_pqrs: "PQRS",
}